import { TableColumn } from "../table/TableColumn";

const LiftColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "liftName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Building",
        accessor: "building",
        isNumeric: false,
        id: 1,
        sortByName: "building.buildingName",
        sortDirection: "asc",
        searchOnName: "building.id",
        lookupName: "building.buildingName",
        active: true,
        translationKey: "building"
    },
    {
        heading: "Floors",
        accessor: "floors",
        isNumeric: true,
        id: 2,
        active: true,
        translationKey: "floors"
    },
    {
        heading: "Reader",
        accessor: "readerName",
        isNumeric: true,
        id: 3,
        active: true,
        translationKey: "reader"
    },
    {
        heading: "IO Modules",
        accessor: "ioModules",
        isNumeric: true,
        id: 4,
        active: true,
        translationKey: "ioDevices"
    },
    // {
    //     heading: "Access Groups",
    //     accessor: "accessGroup",
    //     isNumeric: false,
    //     id: 3,
    //     sortByName: "accessGroup.agName",
    //     sortDirection: "asc",
    //     active: true,
    //     translationKey: "accessGroups"
    // },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 5,
        sortByName: "building.site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "building.site.id",
        lookupName: "building.site.siteName",
        translationKey: "site"
    },
];

export default LiftColumns;
